module.exports = __webpack_public_path__ + "img/documento-martelo.2804b740.svg";